import { Injectable } from '@angular/core';
import { OrganizationModel } from '../../../../core/models/resources/organization.model';
import {HttpService, PaginatedResponse} from '../http-service/http.service';
import { ResourceContentService } from '../content/resource-content.service';
import {map, Observable} from 'rxjs';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import { ServiceModule } from '../../../service.module';
import {UniqueLabels} from "../../../../core/helpers/Const";
import {Utils} from "../../../../core/helpers/Utils";

@Injectable({ providedIn: ServiceModule })
export class OrganizationService extends ResourceContentService<OrganizationModel> {
    constructor(protected override httpService: HttpService<OrganizationModel>) {
        super(httpService);
    }

    getPage(pageSize: number, filter?: string, sort?: string, ascending?: boolean, continueToken?: string): Observable<PaginatedResponse<OrganizationModel[]>> {
        return super.getListPage(pageSize, filter, sort, ascending, continueToken).pipe(map((data) => {
            data.data.forEach(org => this.enrichOrganization(org));
            return data;
        }));
    }

    enrichOrganization(organization: OrganizationModel) {
        if (organization.labels) {
            let costObject = organization.labels[UniqueLabels.COST_OBJECT_KEY];
            if (costObject) {
                organization.costObject = costObject;
            }
            delete organization.labels[UniqueLabels.COST_OBJECT_KEY];
        }

        organization.state = Utils.getState(organization, false);

        if (!organization.displayName) {
            organization.displayName = organization.name;
        }

        return organization;
    }

    getResourceUrl(): string {
        return 'organizations';
    }
}
